import { SentryErrorComponent } from '@components/Fallback'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const CommentaryBoxRoute = () => <Outlet />

export const Route = createFileRoute('/_auth/o/$orgId/commentaryBox')({
  component: CommentaryBoxRoute,
  errorComponent: SentryErrorComponent,
  loader: async () => ({
    crumb: 'Commentary Box',
  }),
})
